export enum OpenOpportunitiesCardTypes {
  NO_RESPONSE = 'NO_RESPONSE',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  NO_OPPORTUNITIES = 'NO_OPPORTUNITIES',
  RESPONSE_RATE = 'RESPONSE_RATE',
  OPEN_OPPORTUNITIES = 'OPEN_OPPORTUNITIES',
}
